import utilService from '../services/UtilService';


const types = {
    SNAPSHOTS_ADD_SNAPSHOT: 'SNAPSHOTS_ADD_SNAPSHOT',
};

const snapshotsActions = {
    types,

    addSnapshot(questionId, interactionId, content) {
        return {
            content,
            interactionId,
            questionId,
            time: utilService.getIsoDateStamp(),
            type: types.SNAPSHOTS_ADD_SNAPSHOT,
        };
    },
};

export default snapshotsActions;
